<template>
  <v-menu :close-on-content-click="false" max-width="320" offset-x>
    <template v-slot:activator="{ on }">
      <FilterBottom v-on="on" />
    </template>

    <v-card>
      <v-container>
        <BaseFilter
          prepend-inner-icon="mdi-file-table-box-multiple-outline"
          clearable
          single-line
          label="Módulo"
          item-text="modulo"
          item-value="id_modulo"
          service="sistemaService.modulos"
          v-model="filters.id_modulo"
          @change="handleFilter()"
        />

        <BaseFilter
          prepend-inner-icon="mdi-domain"
          clearable
          single-line
          label="Menu"
          item-text="descricao"
          item-value="id"
          service="sistemaService.menus"
          v-model="filters.id"
          @change="handleFilter()"
        />
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
import BaseFilter from "@/components/shared/BaseSelectService";
import FilterBottom from "@/components/shared/bottons/FilterBottom";

export default {
  components: {
    BaseFilter,
    FilterBottom
  },

  data() {
    return {
      filters: {}
    };
  },

  methods: {
    handleFilter() {
      this.$emit("selectedFilters", this.filters);
    },
    assignDateFilter(date) {
      this.filters["ano_ref"] = date?.ano_ref;
      this.filters["mes_ref"] = date?.mes_ref;
      this.handleFilter();
    }
  }
};
</script>

<style></style>
